import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs';
import { IPreviousRoute } from '../models/route.model';

@Injectable({
  providedIn: 'root',
})
export class RouterHelperService {
  public currentRoute = '';

  constructor(private router: Router, private location: Location) {
    this.router.events
      .pipe(filter((evt: any) => evt instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute = event.url;
      });
  }

  public goBack() {
    history.back();
  }

  public goTo(url: string) {
    this.router.navigateByUrl(url);
  }

  public navigateWithCurrentRouteDetails(path: string, currentPageName: string) {
    this.router.navigateByUrl(path, {state: {previousPath: this.currentRoute, name: currentPageName} as IPreviousRoute });
  }

  get previousRouteInfo() {
    return history.state as IPreviousRoute;
  }

}
